<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="500" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pb-3.text-center(style="word-break: break-word;" :class="$vuetify.breakpoint.smAndUp ? 'px-8 pt-8' : 'px-4 pt-4'") {{ $t('select_dates_override') }}
      v-card-text.pa-0
        div(align="center")
          v-card.mt-3.mb-8(outlined max-width="350")
            yc-date-picker(:parentDate.sync="selectedDate" :range="true")
        div.neutral300.py-4(v-if="selectedDate.length > 0" :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-4'")
          div.text-sm.font-semibold.neutral700--text {{ $t('set_new_timing') }}
          div.text-xs.neutral700--text.mt-1 {{ $t('set_new_timing_desc') }}

          v-form(ref="form")
            v-row.mt-4(no-gutters)
              v-col(cols="12" sm="8")
                template(v-if="slots.length > 0")
                  div.d-flex.mb-3(v-for="(slot, slindex) in slots" :key="'slot-' + slindex")
                    v-text-field.text-md.font-normal.round-xl(v-model="slot.begin" type="time" background-color="basic100" outlined :rules="rules.not_empty" dense height="48" hide-details="hide")
                    div.mt-3.mx-3 -
                    v-text-field.text-md.font-normal.round-xl(v-model="slot.end" type="time" background-color="basic100" outlined :rules="rules.not_empty" dense height="48" hide-details="hide")
                    v-btn.mt-3.ml-3(small icon @click="deleteSlot(slindex, slots)")
                      v-icon(color="neutral700" size="18") $yzi-trash-03
                div.text-md.neutral500--text.mt-3(v-else) {{ $t('unavailable') }}
              v-col(cols="12" sm="4" align="end")
                v-btn.mt-3(small icon @click="addSlot(slots)")
                  v-icon(color="neutral700" size="18") $yzi-plus
      v-divider
      v-card-actions.py-3(:class="$vuetify.breakpoint.smAndUp ? 'px-6' : 'px-4'")
        v-btn.button-md.neutral700--text.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(color="neutral700" :dark="Boolean(selectedDate.length > 0)" :disabled="selectedDate.length === 0" :loading="isLoading" @click="applyData") {{ $t('apply') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OverrideDateDialog',
  props: ['open'],
  data: () => ({
    isLoading: false,
    selectedDate: [],
    slots: [{ begin: '09:00:00', end: '17:00:00' }],
    rules: { not_empty: [val => (val || '').length > 0 || 'This field is required'] },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      provider: 'clinic/getProvider'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    addSlot (slots) {
      if (slots.length > 0) {
        let lastSlot = slots[slots.length - 1]
        if (lastSlot.end) {
          let newBegin = Number(lastSlot.end.substr(0, 2)) + 1
          let newEnd = newBegin + 1
          let strNewBegin = newBegin.toString().length > 1 ? (newBegin.toString() + ':00:00') : '0' + (newBegin.toString() + ':00:00')
          let strNewEnd = newEnd.toString().length > 1 ? (newEnd.toString() + ':00:00') : '0' + (newEnd.toString() + ':00:00')
          if (newEnd < 24) {
            slots.push({ begin: strNewBegin, end: strNewEnd })
            return
          }
        }
      }
      slots.push({ begin: null, end: null })
    },
    deleteSlot (index, slots) {
      slots.splice(index, 1)
    },
    applyData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all')])
        return
      }
      let data = {}
      if (this.selectedDate.length > 1) {
        data.begin_date = this.selectedDate[0]
        data.end_date = this.selectedDate[1]
      } else {
        data.begin_date = this.selectedDate[0]
        data.end_date = this.selectedDate[0]
      }
      data.slots = this.slots
      if (this.provider) {
        const endpoint = `/clinics/${this.company.slug}/providers/${this.provider.id}/date_overrides`
        this.$axios.post(endpoint, data)
          .then(resp => {
            this.updateActivityLog(endpoint, data, resp, 'POST', this.provider.id)
            this.$emit('addNewOverride', data)
            this.showDialog = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          }) 
      } else {
        this.$emit('addNewOverride', data)
        this.showDialog = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'provider',
        activity: 'Update provider (provider availability)',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  },
}
</script>

<style>

</style>